// extracted by mini-css-extract-plugin
export default {"home":"home_home__makBP","header":"home_header__ktgNJ","boards":"home_boards__6Z3qL","createBoardButton":"home_createBoardButton__Uk9y8"};